/* eslint-disable react/prop-types */
/**
 *  注意 提示文本
 */
import { Typography } from 'antd';
import React from 'react';
// import style from './index.less'
const { Text } = Typography;

const AttentionTip = (props) => {
  const { text, children } = props;
  return (
    <div>
      <div>{children}</div>
      <div>
        <Text type="secondary">{text}</Text>
      </div>
    </div>
  );
};

export default AttentionTip;
